import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram } from "../type";

export interface ICancelUnstakeParams {
  referralProgram: ReferralProgram;
  unstakeAddress: PublicKey;
  escrowAddress: PublicKey;
  stakingAddress: PublicKey;
  owner: PublicKey;
  rentReceiver: PublicKey;
}

export async function createCancelUnstakeIx(
  params: ICancelUnstakeParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    unstakeAddress,
    escrowAddress,
    stakingAddress,
    owner,
    rentReceiver,
  } = params;

  return referralProgram.methods
    .cancelUnstake()
    .accountsPartial({
      unstake: unstakeAddress,
      escrow: escrowAddress,
      staking: stakingAddress,
      owner,
      rentReceiver,
    })
    .instruction();
}
